import script from "./addGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./addGoods.vue?vue&type=script&lang=ts&setup=true"

import "./addGoods.vue?vue&type=style&index=0&id=6fa75af4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa75af4"]])

export default __exports__